import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Stack } from "@mui/system";
import PopupWithButton from "../../components/PopupWithButton";
import { FaShoppingCart } from "react-icons/fa";
import { AiFillCloseCircle } from "react-icons/ai";
import { Slide } from "react-slideshow-image";
import colors from "../../config/colors";
import RangeDatePicker from "../Installer/RangeDatePicker";
import useApi from "../../hooks/useApi";
import apiClient from "../../api/apiClient";
import { toast } from "react-toastify";
import DateRangeIcon from '@mui/icons-material/DateRange';
const Menu = [
  {
    id: 1,
    Image: require("../../assets/img/cars.PNG"),
    name: "Ride Share CAR",
    impression: "27,00000/mth",

    types: ["Uber", "Lyft", "Gig Economy"],

    type: "vehicle",
    Vehicle_info: {
      avg_imp: "1,000,000/mth",
      dimenstions: ["-Compact", "-Midsize", "-XL Vehicle"],
      sold_by: ["Weekly", "Monthly"],
      fule_type: "Gas, hybrid,electric",
    },
    Vehicle_KPI: {
      best_user: [
        "Swram 10+units",
        "one on one",
        "viewers",
        "electric",
        "cars available",
      ],
      local_drivers: ["Professional brand ambassadors", "trustworthy, etc"],
      routes: ["local", "neighborhoods", "residential areas,", "highways"],
    },
    drive_time: {
      hours: "7am to 7pm",
      days: "6 days per week",
      months: "200 hours per mth.",
    },
  },

  {
    id: 2,
    Image: require("../../assets/img/box-truck.PNG"),
    name: "Box Truck",
    impression: "2,700,000/mth",
    types: ["Local", "Commercial", "Lastmile"],

    type: "veicle",
    Vehicle_info: {
      avg_imp: "2,700,000/mth",
      dimenstions: ["Side- 8x26ft", "Rear- 8x8ft", "Front- 3x7ft"],
      sold_by: ["3 months", "6 months", "12 months"],
      ad_space: "500 sq. ft.",
    },
    Vehicle_KPI: {
      best_user: [
        "Local market",
        "saturation,",
        "local street presence",
        "special events",
      ],
      local_drivers: ["Professional brand ambassadors", "trustworthy, etc"],
      routes: [
        "Dedicated daily",
        "routes in",
        "neighbordhoods",
        "and pr highways",
      ],
    },
    drive_time: {
      hours: "7am to 7pm",
      days: "6 days per week",
      months: "200 hours per mth.",
    },
  },
  {
    id: 3,
    Image: require("../../assets/img/semi-truck-home.PNG"),
    name: "Semi-Truck",
    impression: "2,000,000/mth",
    types: ["Fully", "Customizable", "Routes"],

    type: "veicle",
    Vehicle_info: {
      avg_imp: "3,000,000",
      dimenstions: ["Side- 8x53ft", "Rear- 8x8ft"],
      sold_by: ["3 months", "6 months", "12 months"],
      ad_space: "912 sq. ft.",
    },
    Vehicle_KPI: {
      best_user: [
        "Great for multistate",
        "state campaigns,",
        "reach millions of",
        "eyes on highways",
      ],
      local_drivers: ["Commercial", "professional,", "background", "checked"],
      routes: ["Highways", "freeways, long", "distance driving"],
    },
    drive_time: {
      hours: "7am to 7pm",
      days: "6 days per week",
      months: "200 hours per mth.",
    },
  },
  {
    id: 4,
    Image: require("../../assets/img/led-truck-home.PNG"),
    name: "Led Truck",
    impression: "2,000,000/mth",
    types: ["Fully", "Customizable", "Routes"],

    type: "veicle",
    Vehicle_info: {
      avg_imp: "250,000/day",
      dimenstions: ["Side-6.5x11.5ft", "Rear- 6x6ft"],
      sold_by: ["8 hours slots", "3 -days", "Weekly"],
      ad_space: "500 sq. ft.",
    },
    Vehicle_KPI: {
      best_user: [
        "Static/video",
        "displays,",
        "competition",
        "targeting, political",
      ],
      local_drivers: ["Ride Share & Gig"],
      routes: ["100% custom", "routes for client,", "no higways"],
    },
    drive_time: {
      hours: "7am to 7pm",
      days: "6 days per week",
      months: "200 hours per mth.",
    },
  },

  {
    id: 5,
    Image: require("../../assets/img/phopt-shoot.PNG"),
    name: "Photo/Video",
    type: "other",
    description:
      "Introducing Rolling Adz's photoshoot and video package - the perfect way to showcase your advertisement on our mobile billboards in a visually stunning and professional manner. Our package includes photoshoots and video of your advertisement on our box trucks, LED trucks, semi trucks and wrapped cars. You'll receive high-resolution images and videos, professionally edited and ready to use for your website, social media or other marketing materials.",
  },
  {
    id: 6,
    Image: require("../../assets/img/swram.PNG"),
    name: "Swarm",
    type: "other",
    description:
      "Introducing Swarm, the ultimate advertising solution for businesses looking to increase visibility and reach in a specific location. With Swarm, you can send a fleet of advertiser vehicles, including box trucks, LED trucks, and wrapped cars, around a specific location or to and from a specific location. This allows many eyes to be on your advertisement in that specific area and time, maximizing your brand's exposure and impact. Get your message out there with Swarm and drive more customers to your business today.",
  },
  {
    id: 7,
    Image: require("../../assets/img/retargeting-home.PNG"),
    name: "RETARGETING IMPRESSIONS",
    type: "other",
    description:
      "Once a candidate enters the capture radius of a vehicle, their mobile phone's advertising ID is captured by our beacon technology. We can then filter this audience down by over 200 affinity groups (age, gender, income, interests, etc), and serve display ads in-app or in- browser, driving them to your careers page or specific job postings. We can also provide the entire collected audience if you would like to advertise to them through your own channels (sold in 200k impression intervals).",
  },
];

export default () => {
  const [open, setopen] = useState(false);
  const [current, setCurrent] = useState();
  const [selectedDate, setSelectedDate] = useState(null);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const handleIconClick = () => {
    setShowDatePicker(true);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setShowDatePicker(false);
  };
  let initialState = {
    sart_date: "",
    end_date: "",
    address: "",
    radius: "",
    note: "",
  };
  let quantityInitialState = {
    car: 0,
    boxTruck: 0,
    semiTruck: 0,
    LedTruck: 0,
    photoShoot: 0,
    swarm: 0,
    creativeChange: 0,
    impression200k: 0,
  };
  const [cart, setCart] = useState(initialState);
  const [quantities, setQuantities] = useState(quantityInitialState);
  console.log(quantities, "quan");
  const handlecart = (key, value) => {
    setCart({ ...cart, [key]: value });
  };
  const handleQuantity = (key, value) => {
    const numericValue = Number(value);
    setQuantities({ ...quantities, [key]: numericValue });
  };
  const { request, loading, error } = useApi((submiData) =>
    apiClient.post("/addCart", submiData)
  );
  useEffect(() => {
    const fetch = async () => {
      const response = await apiClient.get("/addCart");
      const data = response.data;
      setCart(data);
    };
    fetch();
  }, []);
  const handleSubmitCart = async (e) => {
    e.preventDefault();
    let submiData = {
      ...cart,
      ...quantities,
    };
    const result = await request(submiData);
    if (!result.ok) return toast.error("Error");
    toast.success("cart created Compelete");
  };
  
  return (
    <div>
      
      <form onSubmit={handleSubmitCart}>
        <div className="main py-5">
          <div className="request-sec p-1">
            <div className="container">
              <div className="row roll-roz position-relative">
                <div className="col d-flex justify-content-between">
                  <Link to={"/"}>
                    <button className="bg-transparent border-0">
                      <i className="bi bi-x-circle-fill blue-clr fs-5" />
                    </button>
                  </Link>
                  <div className="text-center">
                    <h3 className="blue-clr p-3 fs-4">YOUR SHOPPING CART</h3>
                  </div>
                  <div>
                    <img
                      className="h-100 w-100"
                      src={require("../../assets/img/rolling_roz.png")}
                      alt="logo"
                    />
                  </div>
                </div>
              </div>
              <div className="row request-main d-flex p-5">
                <div className="col-md-6 col-lg-4">
                  <div className>
                    <label htmlFor="s_date" className="blue-clr w-100 fs-5">
                      Start Date
                    </label>
                    <input
                      type="date"
                      className="w-100 p-2 lh-base rounded fs-6 mt-1"
                      id="s_date"
                      placeholder="input approximate start date"
                    />
                  </div>
                  <div className>
                    <label htmlFor="s_date" className="blue-clr w-100 fs-5">
                      End Date
                    </label>
                    <input
                      type="date"
                      className="w-100 p-2 lh-base rounded fs-6 mt-1"
                      id="s_date"
                      placeholder="input approximate start date"
                    />
                  </div>
                  <div className=" field-drop mt-1">
                    <div className="field mt-2 position-relative mt-1">
                      <div className="dropdown position-absolute w-100 mt-1 p-3">
                        <ul className="list-unstyled d-flex justify-content-between ps-4 pe-4">
                          <li>
                            <div className="checks mt-1">
                              {" "}
                              <input
                                type="checkbox"
                                id
                                className="month-check"
                              />
                              <span className="blue-clr fw-bold lh-base ms-2">
                                2 weeks
                              </span>
                            </div>
                            <div className="checks mt-1">
                              <input
                                type="checkbox"
                                id
                                className="month-check"
                              />
                              <span className="blue-clr fw-bold lh-base ms-2">
                                4 weeks
                              </span>
                            </div>
                            <div className="checks mt-1">
                              <input
                                type="checkbox"
                                id
                                className="month-check"
                              />
                              <span className="blue-clr fw-bold lh-base ms-2">
                                3 months
                              </span>
                            </div>
                          </li>
                          <li>
                            <div className="checks mt-1 ">
                              <input
                                type="checkbox"
                                id
                                defaultChecked
                                className="month-check"
                              />
                              <span className="blue-clr fw-bold lh-base ms-2">
                                6 months
                              </span>
                            </div>
                            <div className="checks mt-1 ">
                              <input
                                type="checkbox"
                                id
                                className="month-check"
                              />
                              <span className="blue-clr fw-bold lh-base ms-2">
                                9 months
                              </span>
                            </div>
                            <div className="checks mt-1 ">
                              <input
                                type="checkbox"
                                id
                                className="month-check"
                              />
                              <span className="blue-clr fw-bold lh-base ms-2">
                                12 months
                              </span>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="mt-1">
                    <label htmlFor="state" className="blue-clr w-100 fs-5 mt-1">
                      State, City, OR Address
                    </label>
                    <input
                      type="email"
                      className="w-100 p-2 lh-base rounded fs-6 mt-1 p-2"
                      id="state"
                      placeholder="input state, city, or address"
                    />
                  </div>
                  <div className="field-drop mt-1">
                    <label htmlFor className="blue-clr fs-5 rounded mt-1">
                      Radius (from location)
                    </label>
                    <div className="field mt-2 position-relative">
                      <label
                        htmlFor
                        id="location"
                        className="w-100 p-2 ride-c w-100 fs-6 rounded lh-base"
                      >
                        input approximate radius (miles)
                      </label>
                      <div className="loc_dropdown position-absolute w-100 mt-1">
                        <span className="ps-1 fs-6">
                          <i className="fa-solid fa-star" /> Recommend
                        </span>
                        <ul className="list-unstyled d-flex justify-content-between ps-4 pe-4">
                          <li className="w-50">
                            <div className="checks mt-1">
                              <input
                                type="checkbox"
                                id
                                className="month-check"
                              />
                              <span className="blue-clr fw-bold lh-base">
                                10 miles
                              </span>
                            </div>
                            <div className="checks mt-1">
                              <input
                                type="checkbox"
                                id
                                className="month-check"
                              />
                              <span className="blue-clr fw-bold lh-base">
                                20 miles
                              </span>
                            </div>
                            <div className="checks mt-1">
                              <input
                                type="checkbox"
                                id
                                className="month-check"
                              />
                              <span className="blue-clr fw-bold lh-base">
                                30 miles
                              </span>
                            </div>
                          </li>
                          <li className="w-50">
                            <div className="checks mt-1">
                              <input
                                type="checkbox"
                                id
                                className="month-check"
                              />
                              <span className="blue-clr fw-bold lh-base">
                                40 miles
                              </span>
                            </div>
                            <div className="checks mt-1">
                              <input
                                type="checkbox"
                                id
                                defaultChecked
                                className="month-check"
                              />
                              <span className="blue-clr fw-bold lh-base">
                                50 miles
                              </span>
                              <i className="fa-solid fa-star ms-1" />
                            </div>
                            <div className="checks mt-1">
                              <input
                                type="checkbox"
                                id
                                className="month-check"
                              />
                              <span className="blue-clr fw-bold lh-base">
                                60 miles
                              </span>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="mt-2">
                    <label htmlFor="note" className="blue-clr w-100 fs-5 mt-1">
                      Notes
                    </label>
                    <textarea
                      name
                      id="note"
                      className="w-100 p-2 lh-base fs-6 rounded mt-1"
                      placeholder="Input notes about campaign"
                      defaultValue={""}
                    />
                  </div>
                </div>
                <div className=" col-md-6 col-lg-4 ps-md-4 mt-4 mt-md-0">
                <div>
</div>

                  <div>
                    <label htmlFor className="blue-clr fs-5">
                      Select Vehicle types
                    </label>
                  </div>
                  <div className=" mt-1 d-flex gap-1">
                    <input
                      min={0}
                      value={quantities.car}
                      type="number"
                      className="px-1 w-100 number rounded fs-6"
                      placeholder="0"
                      onChange={(e) => {
                        handleQuantity("car", e.target.value);
                      }}
                    />
                    <div className="ride-c fs-6 rounded p-2 ms-1 lh-base">
                    
                    <RangeDatePicker 
                      id="calender"
                     hidden
                      style={{width: "60px", height: "40px" }}
                    />
                    </div>
          

                    {/* <input
                      min={0}
                      id="calender"
                      type="date"
                      className="px-1 w-100 number rounded fs-6"
                      placeholder="0qty"
                      /> */}
                    
                    <label
                      onClick={() => {
                        setCurrent(Menu[0]);
                        setopen(true);
                      }}
                      htmlFor
                      className="ride-c w-100 fs-6 rounded p-2 ms-1 lh-base"
                    >
                      <img src={require("../../assets/img/car.png")} alt="" />
                      Ride Share Car
                    </label>
                  </div>
                  <div className=" mt-2 d-flex gap-1">
                    <input
                      min={0}
                      type="number"
                      value={quantities.boxTruck}
                      className="px-1 w-100 number rounded fs-6"
                      placeholder="0"
                      onChange={(e) => {
                        handleQuantity("boxTruck", e.target.value);
                      }}
                    />
                    {/* <input
                      min={0}
                      type="date"
                      className="px-1 w-100 number rounded fs-6"
                      placeholder="0qty"
                    /> */}
                   <div className="ride-c fs-6 rounded p-2 ms-1 lh-base">
                    
                    <RangeDatePicker 
                      id="calender"
                     hidden
                      style={{width: "60px", height: "40px" }}
                    />
                    </div>
                    <label
                      onClick={() => {
                        setCurrent(Menu[1]);
                        setopen(true);
                      }}
                      htmlFor
                      className="ride-c w-100 fs-6 rounded p-2 ms-1 lh-base"
                    >
                      <img
                        src={require("../../assets/img/semi-truck.png")}
                        alt=""
                      />
                      <span className="ps-1">Box Truck</span>
                    </label>
                  </div>
                  <div className="mt-2 d-flex gap-1">
                    <input
                      min={0}
                      type="number"
                      value={quantities.semiTruck}
                      className="px-1 w-100 number rounded fs-6"
                      placeholder="0"
                      onChange={(e) => {
                        handleQuantity("semiTruck", e.target.value);
                      }}
                    />
                    {/* <input
                      min={0}
                      type="date"
                      className="px-1 w-100 number rounded fs-6"
                      placeholder="0qty"
                    /> */}
                   <div className="ride-c fs-6 rounded p-2 ms-1 lh-base">
                    
                    <RangeDatePicker 
                      id="calender"
                     hidden
                      style={{width: "60px", height: "40px" }}
                    />
                    </div>
                    <label
                      onClick={() => {
                        setCurrent(Menu[2]);
                        setopen(true);
                      }}
                      htmlFor
                      className="ride-c w-100 fs-6 rounded p-2 ms-1 lh-base"
                    >
                      <img src={require("../../assets/img/truck.png")} alt="" />
                      <span className="ps-1">Semi-Truck</span>
                    </label>
                  </div>
                  <div className=" position-relative est-imp mt-2" />
                  <div className=" mt-3 d-flex gap-1">
                    <input
                      min={0}
                      type="number"
                      value={quantities.LedTruck}
                      className="px-1 w-100 number rounded fs-6"
                      placeholder="0"
                      onChange={(e) => {
                        handleQuantity("LedTruck", e.target.value);
                      }}
                    />
                    {/* <input
                      min={0}
                      type="date"
                      className="px-1 w-100 number rounded fs-6"
                      placeholder="0qty"
                    /> */}
                  <div className="ride-c fs-6 rounded p-2 ms-1 lh-base">
                    
                    <RangeDatePicker 
                      id="calender"
                     hidden
                      style={{width: "60px", height: "40px" }}
                    />
                    </div>
                    <label
                      onClick={() => {
                        setCurrent(Menu[3]);
                        setopen(true);
                      }}
                      htmlFor
                      className="ride-c w-100 fs-6 rounded p-2 ms-1 lh-base"
                    >
                      <img
                        src={require("../../assets/img/vehicle5.png")}
                        alt=""
                      />
                      <span className="ps-1">LED Truck</span>
                    </label>
                    {/* <input type="number" className="p-2 w-25 rounded ms-1 fs-6" placeholder={3} /> */}
                  </div>

                  <div>
                    <label htmlFor className="blue-clr mt-3 fs-5">
                      Select Special Requests
                    </label>
                  </div>
                  <div className=" mt-2 d-flex gap-1">
                    <input
                      min={0}
                      type="number"
                      value={quantities.photoShoot}
                      className="px-1 w-100 number rounded fs-6"
                      placeholder="0"
                      onChange={(e) => {
                        handleQuantity("photoShoot", e.target.value);
                      }}
                    />
                    {/* <input
                      min={0}
                      type="date"
                      className="px-1 w-100 number rounded fs-6"
                      placeholder="0qty"
                    /> */}
                    <div className="ride-c fs-6 rounded p-2 ms-1 lh-base">
                    
                    <RangeDatePicker 
                      id="calender"
                     hidden
                      style={{width: "60px", height: "40px" }}
                    />
                    </div>
                    <label
                      onClick={() => {
                        setCurrent(Menu[4]);
                        setopen(true);
                      }}
                      htmlFor
                      className="ride-c w-100 fs-6 rounded p-2 ms-1 lh-base"
                    >
                      <img
                        src={require("../../assets/img/camera.png")}
                        alt=""
                      />
                      <span className="ps-1">Photoshoot</span>
                    </label>
                  </div>
                  <div className="mt-2 d-flex gap-1">
                    <input
                      min={0}
                      type="number"
                      value={quantities.swarm}
                      className="px-1 w-100 number rounded fs-6"
                      placeholder="0"
                      onChange={(e) => {
                        handleQuantity("swarm", e.target.value);
                      }}
                    />
                    {/* <input
                      min={0}
                      type="date"
                      className="px-1 w-100 number rounded fs-6"
                      placeholder="0qty"
                    /> */}
                   <div className="ride-c fs-6 rounded p-2 ms-1 lh-base">
                    
                    <RangeDatePicker 
                      id="calender"
                     hidden
                      style={{width: "60px", height: "40px" }}
                    />
                    </div>
                    <label
                      onClick={() => {
                        setCurrent(Menu[5]);
                        setopen(true);
                      }}
                      htmlFor
                      className="ride-c w-100 fs-6 rounded p-2 ms-1 lh-base"
                    >
                      <img src={require("../../assets/img/bee.png")} alt="" />
                      <span className="ps-1">Swarm/Event</span>
                    </label>
                  </div>

                  <div className="mt-2 d-flex gap-1">
                    <input
                      min={0}
                      type="number"
                      value={quantities.creativeChange}
                      className="px-1 w-100 number rounded fs-6"
                      placeholder="0"
                      onChange={(e) => {
                        handleQuantity("creativeChange", e.target.value);
                      }}
                    />
                    {/* <input
                      min={0}
                      type="date"
                      className="px-1 w-100 number rounded fs-6"
                      placeholder="0qty"
                    /> */}
                   <div className="ride-c fs-6 rounded p-2 ms-1 lh-base">
                    
                    <RangeDatePicker 
                      id="calender"
                     hidden
                      style={{width: "60px", height: "40px" }}
                    />
                    </div>
                    <label
                      onClick={() => {
                        setCurrent(Menu[6]);
                        setopen(true);
                      }}
                      htmlFor
                      className="ride-c w-100 fs-6 rounded p-2 ms-1 lh-base"
                    >
                      <img src={require("../../assets/img/brush.png")} alt="" />
                      <span className="ps-1">Creative Change</span>
                    </label>
                  </div>

                  <div className="mt-2 d-flex gap-1">
                    <input
                      min={0}
                      type="number"
                      value={quantities.impression200k}
                      className="px-1 w-100 number rounded fs-6"
                      placeholder="0"
                      onChange={(e) => {
                        handleQuantity("impression200k", e.target.value);
                      }}
                    />
                    {/* <input
                      min={0}
                      type="date"
                      className="px-1 w-100 number rounded fs-6"
                      placeholder="0qty"
                    /> */}
                   <div className="ride-c fs-6 rounded p-2 ms-1 lh-base">
                    
                    <RangeDatePicker 
                      id="calender"
                     hidden
                      style={{width: "60px", height: "40px" }}
                    />
                    </div>
                    <labele
                      htmlFor
                      className="ride-c w-100 fs-6 rounded p-2 ms-1 lh-base"
                    >
                      200K Retarget Impressions
                    </labele>
                  </div>
                </div>
                <div className="col-lg-4 ps-lg-4 mt-4 mt-lg-0">
                  <label className="blue-clr fs-5">Order request</label>
                  <div className="order-req mt-1 pt-3 px-2 position-relative rounded">
                    <span className="cpm p-1 position-absolute">CPM:$0.35</span>
                    <h3 className="fs-6 fw-bold lh-base">EST.Impressions:0</h3>
                    <div className="position-relative est-imp" />
                    <div className="vehicle ">
                      <h4 className="fs-6 fw-bold lh-base">
                        Vehicle Selections (Qty.):
                      </h4>
                    </div>
                    <div className="ride d-flex pe-5 ">
                      <div className="share w-75">
                        <span className="lh-1">Ride Share car (0):</span>
                      </div>
                      <div className="share-ride d-flex justify-content-between w-25">
                      <i class="bi bi-plus"></i>
                        <p>0</p>
                      </div>
                    </div>
                    <div className="ride d-flex pe-5 ">
                      <div className="share w-75">
                        <span className="lh-1">Box Truck (0):</span>
                      </div>
                      <div className="share-ride d-flex justify-content-between w-25">
                        <i class="bi bi-plus"></i>
                        <p>0</p>
                      </div>
                    </div>
                    <div className="ride d-flex pe-5 ">
                      <div className="share w-75">
                        <span className="lh-1">Semi-Truck (0):</span>
                      </div>
                      <div className="share-ride d-flex justify-content-between w-25">
                        <i class="bi bi-plus"></i>
                        <p>0</p>
                      </div>
                    </div>
                    <div className="ride d-flex pe-5 ">
                      <div className="share w-75">
                        <span className="lh-1 fw-normal">LED Truck (0):</span>
                      </div>
                      <div className="share-ride d-flex justify-content-between w-25 led-truck position-relative">
                        <i class="bi bi-plus"></i>
                        <p>0</p>
                      </div>
                    </div>
                    <div className="ride d-flex pe-5 ">
                      <div className="share w-75 ">
                        <span className="fw-bold lh-base ">
                          Total (w/o Requests):
                        </span>
                      </div>
                      <div className="share-ride d-flex justify-content-between w-25 ">
                        <p className="fw-bold lh-base">$</p>
                        <p className="fw-bold lh-base">0</p>
                      </div>
                    </div>
                    <div className="ride d-flex pe-5 ">
                      <div className="share w-75">
                        <span className="fw-normal lh-1">
                          Added Requests (0):
                        </span>
                      </div>
                      <div className="share-ride d-flex justify-content-between w-25">
                        <i class="bi bi-plus"></i>
                        <p>0</p>
                      </div>
                    </div>
                    <div className="ride d-flex pe-5 ">
                      <div className="share w-75">
                        <span className="lh-1 fw-normal">Production Cost:</span>
                      </div>
                      <div className="share-ride d-flex justify-content-between w-25 led-truck position-relative">
                        <i class="bi bi-plus"></i>
                        <p>0</p>
                      </div>
                    </div>
                    <div className="ride d-flex pe-5 ">
                      <div className="share w-75 ">
                        <span className="fw-bold lh-base">Total Cost:</span>
                      </div>
                      <div className="share-ride d-flex justify-content-between w-25 ">
                        <p className="fw-bold lh-base">$</p>
                        <p className="fw-bold lh-base">0</p>
                      </div>
                    </div>
                    <div className="ride d-flex pe-5 ">
                      <div className="share w-75">
                        <span className="fw-bold lh-base">Savings (20%)</span>
                      </div>
                      <div className="share-ride d-flex justify-content-between align-items-center w-25 led-truck position-relative">
                      <i class="bi bi-x"></i>
                        <p className="fw-bold lh-base mb-0">0.80</p>
                      </div>
                    </div>
                    <div className="ride d-flex pe-5 ">
                      <div className="share w-75">
                        <span className="blue-clr fw-bold lh-base">
                          Your Cost:
                        </span>
                      </div>
                      <div className="share-ride d-flex justify-content-between w-25">
                        <p className="blue-clr fw-bold lh-base">$</p>
                        <p className="blue-clr fw-bold lh-base">0</p>
                      </div>
                    </div>
                    <div className="ride d-flex pe-5 mt-1">
                      <div className="share w-75">
                        <span className="blue-clr fw-bold lh-base">
                          Monthly Cost:
                        </span>
                      </div>
                      <div className="share-ride d-flex justify-content-between w-25">
                        <p className="blue-clr fw-bold lh-1">$</p>
                        <p className="blue-clr fw-bold lh-1">0</p>
                      </div>
                    </div>
                    <div className="mt-1">
                      <p className="text-center lh-1 fw-normal">
                        Fixed costs are estimates and subject to change
                      </p>
                    </div>
                  </div>
                  <div className="submit-b mt-2">
                    <Link to={"/submit-request"}>
                      <button
                        type="submit"
                        className="p-2 w-100 fs-4 lh-base rounded"
                      >
                        Submit Request
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      {current && (
        <>
          {current.type == "other" ? (
            <EventCard open={open} item={current} setopen={setopen} />
          ) : (
            <NewCard open={open} item={current} setopen={setopen} />
          )}
        </>
      )}
    </div>
  );
};

function NewCard({ open, setopen, item }) {
  function handleSubmit() {}

  return (
    <PopupWithButton
      title=""
      content={
        <div className="">
          <div className="d-flex justify-content-between align-items-center px-2 ">
            <div onClick={() => setopen(false)}>
              <AiFillCloseCircle size={30} color={colors.primary} />
            </div>
            <h3 className="text_color text-decoration-underline">
              Vehicle: {item.name}
            </h3>

            <div style={{ width: "8rem" }}>
              <img
                width={"100%"}
                src={require("../../assets/img/rolling_roz.png")}
                alt=""
              />
            </div>
          </div>
          <div className="">
            <Slide>
              <div className="each-slide-effect">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundSize: "cover",
                    height: "250px",
                    backgroundImage: `url(${item.Image})`,
                  }}
                >
                  {/* <span>Slide 1</span> */}
                </div>
              </div>
            </Slide>
          </div>
          {/* <img className="card_img_top img-fluid" src={item.Image} alt="Card image" style={{width: '100%', height: 'auto'}} /> */}
          <div className="box_bg p-3 border border-secondary rounded mt-2">
            <h5 className="text_color text-decoration-underline">
              Vehicle Info:
            </h5>
            <div className="row">
              <div className="col-md-4">
                <h6 className="text-muted">Avg.Impression:</h6>

                <p className="fs_14px">{item.Vehicle_info.avg_imp}</p>
                {item.Vehicle_info.ad_space && (
                  <div>
                    <h6 className="text-muted">Ad Space</h6>
                    <p className="fs_14px">{item.Vehicle_info.ad_space}</p>
                  </div>
                )}
                {item.Vehicle_info.fule_type && (
                  <div>
                    <h6 className="text-muted">Fuel Type</h6>
                    <p className="fs_14px">{item.Vehicle_info.fule_type}</p>
                  </div>
                )}
              </div>

              <div className="col-md-4">
                <h6 className="text-muted">Dimensions:</h6>
                {item.Vehicle_info.dimenstions.map((subitem) => (
                  <p className="fs_14px">{subitem}</p>
                ))}
              </div>
              <div className="col-md-4">
                <h6 className="text-muted">Sold By:</h6>{" "}
                {item.Vehicle_info.sold_by.map((subitem) => (
                  <div className="p-1">
                    <input type="checkbox" disabled checked name="" id="" />

                    <label className="fs_14px ps-1" htmlFor="">
                      {subitem}
                    </label>
                  </div>
                ))}
              </div>
            </div>
            <h5 className="text_color text-decoration-underline">
              Vehicle KPI's:
            </h5>
            <div className="row">
              <div className="col-md-4">
                <h6 className="text-muted">Best Uses:</h6>

                {item.Vehicle_KPI.best_user.map((subitem) => (
                  <p className="fs_14px m-0">{subitem}</p>
                ))}
              </div>

              <div className="col-md-4">
                <h6 className="text-muted">Local Drivers:</h6>

                {item.Vehicle_KPI.local_drivers.map((sub) => (
                  <p className="fs_14px m-0">{sub}</p>
                ))}
              </div>

              <div className="col-md-4">
                <h6 className="text-muted">Routes:</h6>
                {item.Vehicle_KPI.routes.map((subitem) => (
                  <p className="fs_14px m-0">{subitem}</p>
                ))}
              </div>
            </div>

            <h5 className="text_color text-decoration-underline">
              Drive Time:
            </h5>
            <div className="row">
              <div className="col-md-4">
                <h6 className="text-muted">Hours:</h6>
                <p>{item.drive_time.hours}</p>
              </div>

              <div className="col-md-4">
                <h6 className="text-muted">Days:</h6>
                <p className="fs_14px">{item.drive_time.days}</p>
              </div>
              <div className="col-md-4">
                <h6 className="text-muted">Months:</h6>
                <p className="fs_14px">{item.drive_time.months}</p>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center gap-1 mt-2">
            <div>
              <input
                min={0}
                type="number"
                name=""
                id=""
                style={{ width: "4rem", height: "3rem" }}
                placeholder="0 Qty"
              />
            </div>
            <div>
              <button className="btn btn_bg px-4 py-3">
                Add to Cart
                <FaShoppingCart size={25} style={{ paddingLeft: "5px" }} />
              </button>
            </div>
          </div>
        </div>
      }
      isOpen={open}
      // loading={loading}
      yesName=""
      yesClick={handleSubmit}
      cancelName=""
      cancelClick={() => setopen(false)}
    />
  );
}

function EventCard({ open, setopen, item }) {
  console.log(item);
  function handleSubmit() {}

  return (
    <PopupWithButton
      title=""
      content={
        <>
          <div className="d-flex justify-content-between align-items-center px-2">
            <div onClick={() => setopen(false)}>
              <AiFillCloseCircle size={30} color={colors.primary} />
            </div>
            <h3 className="text_color text-decoration-underline">
              {item.name}
            </h3>
            <div style={{ width: "8rem" }}>
              <img
                width={"100%"}
                src={require("../../assets/img/rolling_roz.png")}
                alt=""
              />
            </div>
          </div>
          <Stack>
            <Slide>
              <div className="each-slide-effect">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundSize: "cover",
                    height: "250px",
                    backgroundImage: `url(${item.Image})`,
                  }}
                >
                  {/* <span>Slide 1</span> */}
                </div>
              </div>
            </Slide>
          </Stack>
          <div className="box_bg p-3 border border-secondary rounded mt-2">
            <h5 className="text_color text-decoration-underline">
              Product Description:
            </h5>
            <p>{item.description}</p>
          </div>
          <div className="d-flex justify-content-center align-items-center gap-1 mt-2">
            <div>
              <input
                min={0}
                type="number"
                name=""
                id=""
                style={{ width: "4rem", height: "3rem" }}
                placeholder="0 Qty"
              />
            </div>
            <div>
              <button className="btn btn_bg px-4 py-3">
                Add to Cart
                <FaShoppingCart size={25} style={{ paddingLeft: "5px" }} />
              </button>
            </div>
          </div>
        </>
      }
      isOpen={open}
      // loading={loading}
      yesName=""
      yesClick={handleSubmit}
      cancelName=""
      cancelClick={() => setopen(false)}
    />
  );
}
